import * as NUMBER from 'constant/number'
import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { editAuthor, getPotentialAuthors, resetAuthor } from 'action/article'
import { Form, Modal } from 'antd'
import FormModal from 'view/component/form-modal'
import PropTypes from 'prop-types'
import Loader from 'view/component/loader'
import AuthorForm from './author-form'

const { success, error } = Modal

const buildSuccessObject = (response) => ({
  centered: true,
  content: `${response.response}`,
  title: 'Author edited'
})

const buildErrorObject = (response) => ({
  centered: true,
  content: response.response,
  title: 'An Error has occured'
})

const getAuthorForm = (form, article, authors) => (
  <AuthorForm
    article={article}
    authors={authors}
    form={form}

  />
)

const EditAuthor = ({ editAuthor, article, getPotentialAuthors, authors, loader, resetAuthor }) => {
  const [visible, setVisible] = useState(false)
  const [form] = Form.useForm()
  const handleClick = async () => {
    setVisible(true)
    await getPotentialAuthors(article)
  }

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      const response = await editAuthor({ ...values, title: article.title, uuid: article.uuid })
      setVisible(false)
      await resetAuthor()
      !response.error ? success(buildSuccessObject(response)) : error(buildErrorObject(response))
    }).catch(({ errorFields }) => form.scrollToField(errorFields[NUMBER.ZERO].name[NUMBER.ZERO]))
  }

  return (
    <>
      <a onClick={handleClick}>Edit Author</a>
      <FormModal
        handleSubmit={handleSubmit}
        loading={loader}
        onCancel={() => {
          setVisible(false)
        }}
        title='Edit author'
        visible={visible}
        width={520}
      >
        {authors
          ? getAuthorForm(form, article, authors)
          : <Loader relative />
        }
      </FormModal>

    </>
  )
}

EditAuthor.propTypes = {
  article: PropTypes.object,
  authors: PropTypes.array,
  editAuthor: PropTypes.func,
  getPotentialAuthors: PropTypes.func,
  loader: PropTypes.bool
}

const mapStateToProps = (state) => ({
  authors: state.article.authors,
  loader: state.loader.articleSubmitting
})

const mapDispatchToProps = (dispatch) => ({
  editAuthor: bindActionCreators(editAuthor, dispatch),
  getPotentialAuthors: bindActionCreators(getPotentialAuthors, dispatch),
  resetAuthor: bindActionCreators(resetAuthor, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(EditAuthor)
